import { TSupersetField} from '@/interfaces/common'
import rison from 'rison';

export const parseRisonForSP = (fieldData: TSupersetField, itemsFilter: string): string => {
    const value = Array.isArray(itemsFilter) ? [...itemsFilter] : [itemsFilter];
    const risonObject = rison.encode_object({
        [`NATIVE_FILTER-${fieldData.id}`]: {
            __cache: {
                label: itemsFilter,
                validateStatus: false,
                value,
            },
            extraFormData: {
                filters: [
                    {
                        col: fieldData.targets,
                        op: 'IN',
                        val: value,
                    },
                ],
            },
            filterState: {
                label: itemsFilter,
                validateStatus: false,
                value,
            },
            id: `NATIVE_FILTER-${fieldData.id}`,
            ownState: {},
        },
    });

    return risonObject;
};
